/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Weary_Caring_Puma_BreatheInputs */

const en_weary_caring_puma_breathe = /** @type {(inputs: Weary_Caring_Puma_BreatheInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neutrals`)
};

const de_weary_caring_puma_breathe = /** @type {(inputs: Weary_Caring_Puma_BreatheInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neutrale`)
};

/**
* | output |
* | --- |
* | "Neutrals" |
*
* @param {Weary_Caring_Puma_BreatheInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const weary_caring_puma_breathe = /** @type {((inputs?: Weary_Caring_Puma_BreatheInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Weary_Caring_Puma_BreatheInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_weary_caring_puma_breathe(inputs)
	return de_weary_caring_puma_breathe(inputs)
});